import { createSlice } from '@reduxjs/toolkit';

interface UIState {
    isSidebarOpen: boolean;
    isSidebarOpenOnMobile: boolean;
}

const readSidebarOpen = (): boolean => {
    const stored = localStorage.getItem('sidebarState');
    if (stored === 'open') return true;
    if (stored === 'closed') return false;
    return true;
};

const initialState: UIState = {
    isSidebarOpen: readSidebarOpen(),
    /** Mobile drawer only — never restored from storage (would block desktop collapse). */
    isSidebarOpenOnMobile: false,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.isSidebarOpen = !state.isSidebarOpen;
            localStorage.setItem('sidebarState', state.isSidebarOpen ? 'open' : 'closed');
        },
        toggleSidebarOnMobile: (state) => {
            state.isSidebarOpenOnMobile = !state.isSidebarOpenOnMobile;
        },
        closeSidebarOnMobile: (state) => {
            state.isSidebarOpenOnMobile = false;
        },
    },
});

export const { toggleSidebar, toggleSidebarOnMobile, closeSidebarOnMobile } = uiSlice.actions;
export default uiSlice.reducer;
